
export const SIGN_IN_START = "SIGN_IN - Start";
export const SIGN_IN_COMPLETED = "SIGN_IN - Completed";
export const SIGN_IN_FAILED = "SIGN_IN - Failed";
export const SIGN_OUT = "SIGN_OUT - SIGN_OUT";

export const REFRESH_TOKEN_START = "REFRESH_TOKEN - Start";
export const REFRESH_TOKEN_COMPLETED = "REFRESH_TOKEN - Completed";
export const REFRESH_TOKEN_FAILED = "REFRESH_TOKEN - Failed";
